module.exports = __webpack_public_path__ + "static/img/sina.754c58f3.svg";